import { IPaginator } from './paginator';
import { colors } from '../theme/colors';

export enum CaseStatus {
  PENDING_ALLOCATION = 'c7e4f1a8-2b6d-4e0a-91c3-7f5d8a3b2e10',
  PENDING_VERIFICATION = '3bd35d77-782b-435f-9914-cbaeff7e544a',
  IN_PROGRESS = 'ce020786-5c40-4243-bb2e-6153fc192d5c',
  SUPERVISOR_REVIEW = '0f4c1f0c-2a2b-4c69-a4d4-8b9e1f1f2c33',
  WAITING_FOR_DECISION = '71c911a9-454d-43fd-a798-f22e2acb7e1d',
  GRANTED = '8d6273cb-397b-473a-8429-662af85df970',
  CLOSED = '3c12376e-65b2-4048-ab4c-aeacb7a9ade8',
  REFUSED = '57a8feae-aaf4-41e6-ba87-ee308aee2e5a',
  REJECTED = '895b3844-e337-459d-80a7-d619128ce0fe',
}
export enum ECaseRenewalStatus {
  EXISTS_NOT_FINISHED = 'EXISTS_NOT_FINISHED',
  EXISTS_GRANTED = 'EXISTS_GRANTED',
  EXISTS_DENIED = 'EXISTS_DENIED',
  NOT_EXISTS = 'NOT_EXISTS',
  GENERIC_EXISTS_NOT_FINISHED = 'GENERIC_EXISTS_NOT_FINISHED',
}
export enum ECaseVariationStatus {
  EXISTS_NOT_FINISHED = 'EXISTS_NOT_FINISHED',
  EXISTS_GRANTED = 'EXISTS_GRANTED',
  EXISTS_DENIED = 'EXISTS_DENIED',
  NOT_EXISTS = 'NOT_EXISTS',
}

export const REVIEW_APPLICATION_CASE_STATUSES = [
  CaseStatus.IN_PROGRESS,
  CaseStatus.SUPERVISOR_REVIEW,
  CaseStatus.WAITING_FOR_DECISION,
  CaseStatus.GRANTED,
  CaseStatus.CLOSED,
  CaseStatus.REFUSED,
  CaseStatus.REJECTED,
];

export const REPRINT_LICENCE_CASE_STATUSES = [CaseStatus.IN_PROGRESS];

export const FINAL_CASE_STATUSES = [
  CaseStatus.GRANTED,
  CaseStatus.REFUSED,
  CaseStatus.REJECTED,
  CaseStatus.CLOSED,
];
export enum CaseProcessTypes {
  APPLICATION = '7f4a6d51-3bb7-4d9e-9e2a-1c0b5d8a9e72',
}

export const CaseStatusColors = {
  [CaseStatus.PENDING_ALLOCATION]: colors.gray100,
};

export enum ECaseSortType {
  Cases = 'Cases',
  Comments = 'Comments',
  Attachments = 'Attachments',
  History = 'History',
}

export interface ICommentsResponse {
  uniqueId: string;
  creationDate: string;
  author: string;
  message: string;
}
export interface IRaportResponse {
  uniqueId: string;
  sourceSystem: string;
  trace: string;
  lastUpdate: string;
  lastAuthor: string;
}
export interface INoteFormValue {
  name: string;
  description: string;
}
export interface ITaskFormValue {
  nameUniqueId: string;
  description: string;
}
export interface IEditTaskFormValue {
  comment: string;
  statusUniqueId: string;
}

export interface INote {
  uniqueId: string;
  caseUniqueId: string;
  name: string;
  description: string;
  lastAuthorUniqueId: string;
  lastAuthor: string;
  lastModifiedDate: string;
}

export interface INotesResponse extends IPaginator {
  content: INote[];
}

export interface IReports {
  uniqueId: string;
  sourceSystem: string;
  trace: boolean;
  lastUpdate: string;
  lastAuthorUniqueId: string;
  lastAuthorDisplayUniqueId: string;
  lastAuthorName: string;
  fromTemplate: boolean;
  hasResults: boolean;
}
export interface IReportsResponse extends IPaginator {
  content: IReports[];
}
export interface IReportAttachment {
  uniqueId: string;
  filename: string;
  extension: string;
  preassignedUrl: string;
}
export interface IReport {
  uniqueId: string;
  sourceSystem: string;
  sourceSystemUniqueId: string;
  trace: true;
  instructions: string;
  conclusions: string;
  lastUpdate: string;
  lastAuthorUniqueId: string;
  lastAuthorDisplayUniqueId: string;
  lastAuthorName: string;
  fromTemplate: true;
  attachments: IReportAttachment[];
  hasResults: true;
}
export interface IReportFormValue {
  sourceSystemUniqueId: string;
  instructions: string;
}
export interface IReportResultFormValue {
  trace: boolean | null;
  conclusions: string;
  attachments: File[] | null;
  deletedAttachmentsUniqueIds?: string[];
}
export interface IReportCreateRequest {
  request: {
    trace: boolean;
    conclusions?: string;
  };
  attachments?: File[] | null;
}
export interface IReportEditRequest {
  request: {
    trace: boolean;
    conclusions?: string;
    deletedAttachmentsUniqueIds: string[];
  };
  attachments?: File[] | null;
}

export interface ITask {
  uniqueId: string;
  name: string;
  lastUpdate: string;
  lastAuthorUniqueId: string;
  lastAuthorDisplayUniqueId: string;
  lastAuthorName: string;
  statusUniqueId: string;
  status: string;
  fromTemplate: string;
}

export interface ITasksResponse extends IPaginator {
  content: ITask[];
}
export interface ITaskComment {
  comment: string;
  authorUniqueId: string;
  authorDisplayUniqueId: string;
  authorName: string;
  createdDate: string;
}
export interface ITaskComments {
  uniqueId: string;
  name: string;
  description: string;
  statusUniqueId: string;
  status: string;
  comments: ITaskComment[];
}
export interface ICaseHistory {
  uniqueId: string;
  caseStatusUniqueId: string;
  caseStatus: string;
  description: string;
  authorUniqueId: string;
  authorDisplayUniqueId: string;
  authorName: string;
  createdDate: string;
}

export interface ICaseHistoryResponse extends IPaginator {
  content: ICaseHistory[];
}

export interface ICase {
  uniqueId: string;
  caseNumber: string;
  legalUniqueId: string;
  legalType: string;
  legalName: string;
  processTypeUniqueId: string;
  licenceAuthorityUniqueId: string;
  statusUniqueId: string;
  decisionDate: string;
  assignedTo: string;
  assignedToUniqueId: string;
  createdDate: string;
  paymentStatusUniqueId: string;
  price: string;
  licenceTemplateCode: string;
  licenceTemplateName: string;
  licenceTemplateUniqueId: string;
  isUnderVerification: boolean;
  canCreateLicence: boolean;
  summaryReportGenerated: boolean;
  summaryReportFileName: string;
  taskName: string;
  taskNameUniqueId: string;
  taskDescription: string;
  summary: string;
  weaponLicenceUniqueId?: string;
  canRenew?: boolean;
  canVary?: boolean;
  reprintEnqueued?: boolean;
  reprintSent?: boolean;
  reprintedLicenceUniqueId?: string;
  reprintedLicenceName?: string;
  reprintedLicenceNumber?: string;
  weaponLicenceNumber: string;
  weaponLicenceStartDate: string;
  weaponLicenceEndDate: string;
}
export interface ICaseResponse extends IPaginator {
  content: ICase[];
}
export interface ICaseLicence {
  uniqueId: string;
  licenceNumber: string;
  statusUniqueId: string;
  startDate: string;
  expiryDate: string;
  assets: {
    uniqueId: string;
    fireCycleId: string;
  }[];
  assetCount: number;
  createdDate: string;
  createdBy: string;
  createdByDisplayUniqueId: string;
  createdByName: string;
}
export interface ICaseLicencesResponse extends IPaginator {
  content: ICaseLicence[];
}

export enum EDecisionTypes {
  approved = 'approved',
  refused = 'refused',
}

export interface ICaseDecision {
  uniqueId: string;
  caseUniqueId: string;
  decision: string;
  reasons: string[];
  comment: string;
  authorName: string;
  authorDisplayUniqueId: string;
  authorUniqueId: string;
  createdDate: string;
}

export interface IDecisionFormValues {
  decision: string;
  reasonUniqueIds: string[];
  comment: string;
}

export interface IRejectCaseFormValues {
  reasonUniqueIds: string[];
  comment: string;
}

export interface IAssignedUsers {
  uniqueId: string;
  firstName: string;
  lastName: string;
  displayUniqueId: string;
}
export interface IAssignedUsersResponse extends IPaginator {
  content: IAssignedUsers[];
}
export interface ICaseForLe {
  uniqueId: string;
  caseNumber: string;
  licenceTemplateCode: string;
  licenceTemplateName: string;
  licenceTaskName: string;
  createdDate: string;
  statusUniqueId: string;
  assignedTo: string;
  assignedToDisplayUniqueId: string;
  assignedToUniqueId: string;
  licenceAuthorityUniqueId: string;
}
export interface IFileReview {
  uniqueId: string;
  caseUniqueId: string;
  attachmentUniqueId: string;
  processTypeUniqueId: string;
  licenceTemplateCode: string;
  licenceTemplateName: string;
  filename: string;
  fileType: string;
  caseNumber: string;
  presignedUrl: string;
}

export interface ICaseForLeResponse extends IPaginator {
  content: ICaseForLe[];
}
export interface ICaseFormValues {
  legalName: string;
  legalUniqueId: string;
  licenceAuthorityUniqueId: string;
  paymentStatusUniqueId: string;
  processTypeUniqueId: string;
  licenceCodeName: string;
  applicationFiles: File[] | null;
  applicationsFilenames: string[];
  applicationProcessUniqueId?: string;
  description?: string;
  taskNameUniqueId?: string;
  weaponLicenceUniqueId?: string;
  workerUniqueId?: string;
  documents: { [key: string]: File[] } | null;
  documentsFilenames: { [key: string]: string[] } | null;
  documentWillUploadLetter: {
    [key: string]: boolean;
  } | null;
}

export interface ICaseRequest {
  request: {
    legalUniqueId: string;
    licenceAuthorityUniqueId: string;
    paymentStatusUniqueId: string;
    processTypeUniqueId: string;
    weaponLicenceTemplateUniqueId: string;
    documentTemplateUniqueIds: string[];
    documentsFilenames: string[];
    applicationsFilenames: string[];
  };
  applicationFiles: File[] | null;
  documents: File[] | null;
}
export interface IOtherCaseRequest {
  legalUniqueId: string;
  licenceAuthorityUniqueId: string;
  taskNameUniqueId: string;
  weaponLicenceUniqueId?: string;
  workerUniqueId: string;
  description: string;
}
export interface IWeaponLicenceTemplatesDocument {
  uniqueId: string;
  typeUniqueId: string;
  importantNotice: string;
  applicationProcessId: string;
}
export interface IWeaponLicenceTemplates {
  uniqueId: string;
  code: string;
  name: string;
  internalDescription: string;
  documents: IWeaponLicenceTemplatesDocument[];
}

export interface ICaseSearchForLe {
  processTypeUniqueId: string;
  caseNumber: string | undefined;
  statusUniqueId: string[] | undefined;
}

export interface ICaseFile {
  uniqueId: string;
  caseUniqueId: string;
  attachmentUniqueId: string;
  attachmentPresignedUrl: string;
  thumbnailPresignedUrl: string;
  name: string;
  type: string;
  lastCommentAuthorName: string;
  lastCommentAuthorDisplayUniqueId: string;
  lastCommentDate: string;
  lastCommentBy: string;
  reviewed: boolean;
}
export interface IAttachment {
  uniqueId: string;
  name: string;
  extension: string;
}
export interface ICaseAttachmentResponse {
  uniqueId: string;
  typeUniqueId: string;
  importantNotice: string;
  attachments: IAttachment[];
}

export interface IDocumentsFormValues {
  caseUniqueId: string;
  documentTypeUniqueId?: string;
  documentRequirementUniqueId?: string;
  fileNames?: string[];
  documents: File[] | null;
}
export interface ICaseDocumentsRequest {
  request: {
    caseUniqueId?: string;
    documentTypeUniqueId?: string;
    documentRequirementUniqueId?: string;
    fileNames?: string[];
  };
  documents: File[] | null;
}

export interface ICaseWorker {
  uniqueId: string;
  firstName: string;
  lastName: string;
  displayUniqueId: string;
}
export interface ICaseReprintLicence {
  uniqueId: string;
  licenceName: string;
  licenceNumber: string;
}
export interface IComments {
  uniqueId: string;
  comment: string;
  createdBy: string;
  firstName: string;
  lastName: string;
  username: string;
  createdDate: string;
  edited: boolean;
}
export interface IThread {
  uniqueId: string;
  topic: string;
  firstName: string;
  lastName: string;
  username: string;
  createdBy: string;
  lastCommentDate: string;
  comments: IComments[];
}
export interface IApplicationComments extends IThread {
  applicationFileUniqueId: string;
}

export interface ICommentFormValues {
  comment: string;
  topic: string;
}
export interface ICommentForThreadFormValues {
  comment: string;
}
export interface IThreadFormValues {
  topic: string;
}

export interface ICaseThread extends IThread {
  caseUniqueId: string;
  lastCommentBy: string;
}
export interface ISummaryReportData {
  url: string;
}
export interface ICaseOtherComments {
  comment: string;
  authorName: string;
  authorDisplayUniqueId: string;
  authorUniqueId: string;
  createdDate: string;
}
export interface ICaseOtherCommentsResponse extends IPaginator {
  content: ICaseOtherComments[];
}

export interface ICaseOtherCommentFormValue {
  comment: string;
}

export interface IDashboardProcessTypeData {
  [key: string]: number;
}
export interface IDashboardProcessType {
  [key: string]: IDashboardProcessTypeData;
}
export interface ICaseDashboard {
  caseStatistics: {
    caseStatistics: IDashboardProcessType;
  };
  otherRequestStatistics: {
    pendingAllocationAmount: number;
    inProgressAmount: number;
    closedAmount: number;
  };
  caseProcessStatistics: {
    processStatistics: IDashboardProcessType;
  };
  licenceStatusStatistics: {
    licenceStatusStatistics: IDashboardProcessTypeData;
  };
  licenceAlertStatistics: string;
}
export interface ICaseManagementTask {
  uniqueId: string;
  caseNumber: string;
  legalName: string;
  legalUniqueId: string;
  legalType: string;
  taskNameUniqueId: string;
  licenceAuthorityUniqueId: string;
  createdDate: string;
  statusUniqueId: string;
  assignedTo: string;
  assignedToUniqueId: string;
}
export interface ICaseManagementTaskResponse extends IPaginator {
  content: ICaseManagementTask[];
}

export interface ICaseRenewalStatus {
  status: ECaseRenewalStatus;
  caseUniqueId: string;
}
export interface ICaseVariationStatus {
  status: ECaseVariationStatus;
  caseUniqueId: string;
}
